module.exports = __webpack_public_path__ + "static/assets/befec8dfc41e846d9bbe24c87f0a003c.svg";